/* eslint-disable @typescript-eslint/ban-ts-ignore */
/* globals SnapEngage */

import React, { PureComponent } from 'react'
import DisabledButton from './DisabledButton'
import LiveSupportDrawer from './LiveSupportDrawer'
import widgetStyles from './assets/widget.module.scss'
import isSupported from './AvailabilityManager_v2'
import bind from 'lodash/bind'
import chat, { drawerState } from './chat'
import { status } from '@bt-react/constants'
import { LiveSupportWidgetProps, LiveSupportWidgetState } from './types'

const supportedStatuses = [
  status.LIVE_ENABLED,
  status.GOING_LIVE,
  status.LIVE,
  status.OVERRUN,
  status.ENDING_LIVE,
  status.PRE_ROLL_INTERSTITIAL,
  status.POST_ROLL_INTERSTITIAL,
  status.T_MINUS_30
]

class LiveSupportWidget extends PureComponent<LiveSupportWidgetProps, LiveSupportWidgetState> {

  snapEngageLoaded

  state = {
    drawer: {
      open: false,
      type: ''
    } as LiveSupportWidgetState['drawer'],
    isEnabled: false,
    agentsAvailable: false,
    awaitingData: true
  }

  componentDidMount () {

    this.snapEngageLoaded = false
    this.checkAvailability()
  }

  checkAvailability () {

    const shouldBeEnabled = supportedStatuses.includes(this.props.status) &&
      isSupported(this.props.start)

    if (this.state.awaitingData && !shouldBeEnabled) {

      this.setState({

        awaitingData: false

      })

    }
    if (this.state.isEnabled !== shouldBeEnabled) {

      this.setState({

        isEnabled: shouldBeEnabled

      })

    }

  }

  drawerIsOpen (state: LiveSupportWidgetState = this.state): boolean {

    return state.drawer.status === drawerState.OPEN

  }

  drawerIsMinimized () {

    return (this.state.drawer.status === drawerState.MIN)

  }

  componentDidUpdate (prevProps, prevState, snapshot) {

    if (this.drawerIsOpen()) return

    if (((!prevState.isEnabled && this.state.isEnabled) ||
      (this.drawerIsOpen(prevState) && !this.drawerIsOpen())) &&
      !this.snapEngageLoaded) {

      this.snapEngageLoaded = true
      chat.load(bind(this.monitorChat, this))

    }

    if (prevProps.status !== this.props.status ||
      (this.drawerIsOpen(prevState) && !this.drawerIsOpen())) {

      this.checkAvailability()

    }

  }

  monitorChat () {

    chat.agentStatus$()
      .subscribe(
        online => this.setState({ awaitingData: false, agentsAvailable: online })
      )

      chat.drawerStatus$()
      .subscribe(
        // @ts-ignore
        state => this.setState({ drawer: state })
      )

  }

  /**
   * @param value: Boolean to toggle SnapEngage visibility
   * Using custom icon requires using both our custom show/ hide and SnapEngages show button or it doesn't work
   */
  showChatButton (value) {

    const customButton = document.getElementById('designstudio-button')
    if (customButton) {

      customButton.style.display = value ? 'inline' : 'none'
      // @ts-ignore
      value ? SnapEngage.showButton() : SnapEngage.hideButton()

    }

  }

  handleDisabledClick () {

    this.setState({
      drawer: {
        status: drawerState.OPEN,
        type: 'disabled'
      }
    })

  }

  handleMinimiseClick () {

    this.setState({
      drawer: {
        status: drawerState.CLOSED,
        type: 'disabled'
      }
    })

  }

  handleCloseClick () {

    this.setState({
      drawer: {
        status: drawerState.CLOSED,
        type: 'disabled'
      }
    })

  }

  showDisabledButton () {

    return (!this.state.isEnabled || !this.state.agentsAvailable) &&
      !(this.state.drawer.type === 'chat' && (this.drawerIsOpen() || this.drawerIsMinimized()))

  }

  render () {

    const { awaitingData, isEnabled, agentsAvailable } = this.state

    if (awaitingData) return null

    // @ts-ignore
    if (typeof SnapEngage !== 'undefined') {

      this.showChatButton(isEnabled && agentsAvailable && !this.drawerIsMinimized())

    }
    return (
      this.showDisabledButton() ? (

        <div
          className={widgetStyles['container']}
        >
          <DisabledButton
            onClick={() => this.handleDisabledClick()}
          />
          <LiveSupportDrawer
            open={this.drawerIsOpen()}
            onMinimise={() => this.handleMinimiseClick()}
            onClose={() => this.handleCloseClick()}
          />
        </div>

      )
        : null

    )

  }

}

export default LiveSupportWidget
